export const getDisplayName = (rider: Rider): string => {
  let name = rider.nickname;
  if (rider.first_name || rider.last_name)
    name += ` (${rider.last_name?.toUpperCase() || ''}, ${rider.first_name || ''})`;

  return name ?? '';
};

export interface Rider {
  id: string;
  first_name?: string;
  last_name?: string;
  nickname?: string;
  mass?: number;
  time_ref?: number;
  distance_ref?: number;
  speed_ref?: number;
  power_ref?: number;
  [key: string]: any;
}
